export default "https://assets.egbcdn.net/assets/packs/_/images/chat/chat-ban-c89247b5912da05014cad32d9020424f.png";